import { Line } from '@cgs/data-access';
import { WinLineDto } from '../../models';

export function winLineMapper(responseLines: WinLineDto[]): Line[] {
  return responseLines.map((item) => {
    const line = new Line();

    line.positions = item.positions || [];
    line.lineIndex = item.lineNumber;
    line.winAmount = item.win;
    line.multiplier = item.multiplier;
    line.totalWin = item.totalWin;
    line.symbolId = item.symbol;

    return line;
  });
}
